import axios from 'axios';
import { ListPageModel } from '../../../auth/core/_models';

const API_ASSEMP_URL = `${process.env.REACT_APP_ASSEMP_URL}/nucleo-ms/api`;

const PeriodosService = {
    getFindPeriod: async (page = 0, size = 10) => {
        try {
            const response = await axios.get(`${API_ASSEMP_URL}/cursos/periodoInscricao`, {
                params: { page, size }
            });
            return response.data;  
        } catch (error) {
            console.error('Error fetching periods:', error);
            throw error;
        }
    },

    getPeriodById: async (id: number | string): Promise<any> => {
        try {
            const response = await axios.get<any>(`${API_ASSEMP_URL}/cursos/periodoInscricao/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching period with id ${id}:`, error);
            throw error;
        }
    },

    updatePeriod: async (periodData: any): Promise<any> => {
        try {
            const response = await axios.put<any>(`${API_ASSEMP_URL}/cursos/periodoInscricao`, periodData);
            return response.data;
        } catch (error) {
            console.error('Error updating period:', error);
            throw error;
        }
    },

    createPeriod: async (data: any): Promise<any> => {
        try {
            const response = await axios.post<any>(`${API_ASSEMP_URL}/cursos/periodoInscricao`, data);
            return response.data;
        } catch (error) {
            console.error('Error creating period:', error);
            throw error;
        }
    }
};

export default PeriodosService;
